import React, { Fragment,useEffect,useContext } from 'react'
import {AppProjectTree} from '../AppProjectTree'
import {IAppTreeDTO} from '../AppProjectTree/ProjectTreeTable'
import {AppSearchItemProps} from './index'
import {AppTableSearchContext,AppFilter,SearchEnum} from 'qcc'


export const  ProjectTree = (props:AppSearchItemProps) =>{

    const {onItemSearch} = useContext(AppTableSearchContext);

    const handleChange = (data?:IAppTreeDTO) =>{
        let filter:AppFilter = {
            value:data.id.toString(),
            field:props.field || '',
            keyName:props.keyName,
            opr:props.opr || SearchEnum.opr.Equal,
            allowClear:false,
            searchItemType:SearchEnum.itemType.projectFilter
        }
        onItemSearch(filter);
    }

    const renderLable = () =>{
        if(!props.lable) return <Fragment/>
        return <label className='app-search-common-item-lable'>{props.lable}</label>
    }

    return (<div className='app-search-common-item'>
        {renderLable()}
        <div className='app-search-common-item-content' style={{width:props.itemWidth || 300}}> 
            <AppProjectTree scene={props.projectTreeScene || 10000} onChange={handleChange}/>
        </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppProjectTree.tsx